import { inject } from '@angular/core';

import { TimeService } from '@core/common-legacy';

export const TABLE_CELL_TIME_FORMAT = 'DD MMM YYYY';
export const cellTransformFullDate = (input?: string | null) => {
  if (!input) return null;

  return inject(TimeService).format({ input, pattern: TABLE_CELL_TIME_FORMAT });
};
